import { z } from 'zod';
export const connectSageIntacctInputSchema = z.object({
    clientId: z.string().trim().min(1, 'Client ID is required.').max(255, 'Client ID is too long.'),
    clientSecret: z
        .string()
        .trim()
        .min(1, 'Client secret is required.')
        .max(512, 'Client secret is too long.'),
    username: z
        .string()
        .trim()
        .min(1, 'Username is required.')
        .max(255, 'Username is too long.')
        .regex(/^[^@]+@[^@]+$/, 'Enter the username as user@company ID, for example api-user@ACME.'),
});
//# sourceMappingURL=connect-sage-intacct-input-schema.js.map